// import socket from '@/core/services/socket';

import { 
  COMMIT_FETCH_CHANNELS,
  COMMIT_NEW_CHANNEL,
  LISTENER_ACTIVE_USERS,
  LISTENER_NEW_MESSAGE,
  LISTENER_SET_MESSAGE,
  LISTENER_CHANNEL_ACTIVE,
  LISTENER_SET_MESSAGE_CHAT, 
} from '@/store/enums/mutations-types'
import ApiService from "@/core/services/ApiService";

const module = {
  namespaced: true,
  state() {
    return {
      channel: null,
      channels: [],
      channelActive: null,
      newChannel: null,
      index: 0,

    };
  },
  getters: {
    getChannels: (state, getters, rootState, rootGetters) => (search) => {
      return state.channels
        .filter((channel) =>
          channel.name.toLowerCase().includes(search.toLowerCase())
        )
        .map((chanel) => {
          const messages = rootGetters["messages/getUnreadMessages"](chanel.id);
          return {
            ...chanel,
            messages,
          };
        });
    },
    getChannelActive: (state) => {
      return state.channelActive;
    },
    getNewChannel: (state) => {
      return state.newChannel;
    },

  },
  mutations: {
    [COMMIT_FETCH_CHANNELS](state, payload) {
      state.channels = payload;
    },
    [COMMIT_NEW_CHANNEL](state, payload) {
      state.newChannel = payload;
    },
    [LISTENER_ACTIVE_USERS](state, payload) {
      state.channels.forEach((channel) => {
        const user = payload.find(
          (user) => user.user_id == channel.user_id
        );
        if (user) {
          channel.online = user.online;
        }
      });
    },
    [LISTENER_NEW_MESSAGE](state, payload) {
      
      state.channels.forEach((channel) => {
        
         const user = payload && payload.chat_id == channel.chat_id
        if (user && !(payload.Viewed) ) {
          console.log('🚀 ~ state.channels.forEach ~ channel.viewed:', (channel))
          channel.message = payload.user_id == channel.user_id ? payload.content || 'Imagen' : 'Tu: ' + (payload.content || 'imagen'),
          channel.received = payload.created_at_formated ?  payload.created_at_formated : channel.received ,
          channel.viewed = null
        } else if (user && payload.Viewed) {
          console.log('🚀 ~ state.channels.forEach ~ channel.viewed:', (channel))
          channel.viewed = new Date().toLocaleTimeString()
        }
      });
    },
    [LISTENER_SET_MESSAGE](state, payload) {
      state.channels.forEach((channel) => {
        const user = payload == channel.chat_id;
      
        if (user) {
       
          channel.viewed = null
        }
      });
    },
    [LISTENER_SET_MESSAGE_CHAT](state, payload) {
      console.log('🚀 ~ payload set viewed', payload, state.index++)
      state.channels.forEach((channel) => {
        const user = (payload == channel.chat_id);
        console.log('🚀 ~ state.channels.forEach ~ user:', user)
        if (user) {
         if (channel.viewed) return;
          channel.viewed = new Date().toLocaleTimeString()
          console.log('🚀 ~ state.channels.forEach ~ channel:', channel)
        }
      });

    },
    [LISTENER_CHANNEL_ACTIVE](state, payload) {
      state.channelActive = payload;
    },
  },
  actions: {
    async fetchChannels({ commit, state, rootState }, payload = null) {
      
      const { data } = await ApiService.get(`/chat/my-chats`);
      try {
        commit(COMMIT_FETCH_CHANNELS, data.data);
        // socket.emit('message', {
        //   type: 'general',
        //   channel: 'userStatus', // Reemplaza '1' con el ID del canal adecuado
        //   data: {check: true}
        // });
      } catch (error) {
        console.log("🚀 ~ fetchMessages ~ error", error);
      }
    },
    async newChannel({commit, state, rootState}, payload){
      const { data } = await ApiService.get(`/chat/with/${payload}`)
      try {
        
        commit(COMMIT_NEW_CHANNEL, data.data.id)
      } catch (error) {
        console.log('🚀 ~ fetchMessages ~ error', error)
      }
    },
    async setUnread({commit, state, rootState}, payload) {
      const { data } = await ApiService.post(`/chat/unread/${payload}`)
      try {
    
        commit(LISTENER_SET_MESSAGE, payload)
      } catch (error) {
        console.log('🚀 ~ fetchMessages ~ error', error)
      }
    }
  },
};
export default module